import { FieldConfig } from "../../../SetupFormGenerator/types";
import {
  DecoratedMessageWithLinkType,
  DecoratedMessageWithLinkDisplayType,
} from "pages/employer-of-record/components/MessageWithLink/types";
import { DEFAULT_PAYMENT_SETTINGS_FIELDS } from "../DEFAULT/constants";

export enum TaxableBenefits {
  CAR = "Car",
  MEDICAL_INSURANCE = "Medical Insurance",
  LOANS = "Loans",
  LIVING_ACCOMMODATION = "Living Accommodation",
  MEAL_ALLOWANCE = "Meal Allowance",
  EDUCATION = "Education",
  NONCASH_GIFT_AND_AWARDS = "Non-cash gifts & awards",
  RECREATIONAL_FACILITIES_AND_DUES = "Recreational facilities & dues",
}

export const TAXABLEBENFITSVALUES = Object.values(TaxableBenefits);
export const TaxableBenefitsTypeMessage: {
  [key: string]: DecoratedMessageWithLinkType;
} = {
  [""]: {
    text: "To learn more about taxable benefits & allowances in Australia you can refer to the Australian Taxation office.",
    linkText: "Australian Taxation office.",
    link: "https://www.ato.gov.au/forms-and-instructions/approved-forms-consolidated-list-by-tax-topic/fringe-benefits-tax-fbt",
    displayType: DecoratedMessageWithLinkDisplayType.DEFAULT,
  },
} as const;

export const PAYMENT_SETTINGS_FIELDS: FieldConfig[] =
  DEFAULT_PAYMENT_SETTINGS_FIELDS;
